import * as types from 'src/state/ducks/user/types';
import { UserEntity } from 'src/firebase/db/Users';
import { APISuccessfulResponse, APIFailedResponse } from 'src/firebase/db/DatabaseAdapter';
import { ValidationResponse } from 'src/firebase/db/ValidationManager';

export type Actions =
  | GetUsers
  | SuccessGetUsers
  | FailGetUsers
  | GetIdsUsers
  | SuccessGetIdsUsers
  | FailGetIdsUsers
  | InitUser;

/**
 * Get
 */
interface GetUsers {
  type: typeof types.GET_USERS;
  payload: {
    shopId: string;
  };
}
export const getUsers = (payload: GetUsers['payload']) => ({
  type: types.GET_USERS,
  payload,
});

interface SuccessGetUsers {
  type: typeof types.SUCCESS_GET_USERS;
  payload: APISuccessfulResponse<UserEntity[]>;
}
export const successGetUsers = (payload: SuccessGetUsers['payload']) => ({
  type: types.SUCCESS_GET_USERS,
  payload,
});

interface FailGetUsers {
  type: typeof types.FAIL_GET_USERS;
  payload: ValidationResponse | APIFailedResponse;
}
export const failGetUsers = (payload: FailGetUsers['payload']) => ({
  type: types.FAIL_GET_USERS,
  payload,
});

interface GetIdsUsers {
  type: typeof types.GET_IDS_USERS;
  payload: string[];
}
export const getIdsUsers = (payload: GetIdsUsers['payload']) => ({
  type: types.GET_IDS_USERS,
  payload,
});

interface SuccessGetIdsUsers {
  type: typeof types.SUCCESS_GET_IDS_USERS;
  payload: APISuccessfulResponse<UserEntity[]>;
}
export const successGetIdsUsers = (payload: SuccessGetIdsUsers['payload']) => ({
  type: types.SUCCESS_GET_IDS_USERS,
  payload,
});

interface FailGetIdsUsers {
  type: typeof types.FAIL_GET_IDS_USERS;
  payload: ValidationResponse | APIFailedResponse;
}
export const failGetIdsUsers = (payload: FailGetIdsUsers['payload']) => ({
  type: types.FAIL_GET_IDS_USERS,
  payload,
});

/**
 * Init state
 */
interface InitUser {
  type: typeof types.INIT_USER;
}
export const initUser = () => ({
  type: types.INIT_USER,
});
